import React, { useEffect, useRef, useState } from "react";
import { Slot } from "@radix-ui/react-slot";
const ScrollListener = ({ asChild = false, onScroll, children }) => {
  const [element, setElement] = useState(null);
  const onScrollRef = useRef(onScroll);
  onScrollRef.current = onScroll;
  useEffect(() => {
    if (!element || !onScrollRef.current) {
      return void 0;
    }
    const handleScroll = onScrollRef.current;
    element.addEventListener("scroll", handleScroll);
    return () => {
      element.removeEventListener("scroll", handleScroll);
    };
  }, [element]);
  const Component = asChild ? Slot : "div";
  return /* @__PURE__ */ React.createElement(Component, {
    ref: setElement
  }, children);
};
var ScrollListener_default = ScrollListener;
export {
  ScrollListener_default as default
};
